import { atom } from "jotai";

export const solicitudesAusenciaHistoricoAtom = atom([]);